module.exports = __webpack_public_path__ + "static/media/Terasy_u_hranic.83a5efef.md";